import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CarouselProduct from "../../../../../carousels/carousel-product/views/desktop/index.js";
import GridProduct from "../../../../grid-product/index.js";
import { genKey } from "../../../../../../../helpers/keys.js";
import Banner from "../banner/index.js";
import * as S from "./styled.js";
const TabProduct = ({ tab , isLoading =false , config ={} , isFlat , searcher , defaultImage  })=>{
    const tabConfig = {
        ...config,
        ...tab?.config
    };
    const tabILink = typeof tab?.link === 'string' ? {
        href: tab?.link
    } : tab?.link ?? {
        href: ''
    };
    const viewMore = tabILink.content ?? tabConfig.literals?.viewMore;
    const carouselConfig = {
        ...tabConfig,
        literals: {
            ...tabConfig.literals,
            viewMore
        }
    };
    return /*#__PURE__*/ _jsxs(S.TabProduct, {
        "data-testid": "TabProduct",
        $isFlat: isFlat,
        children: [
            (!!tab?.banner || !!tab?.hasImage) && /*#__PURE__*/ _jsx(Banner, {
                banner: tab?.banner,
                link: tabILink.href,
                viewMore: tabConfig?.literals?.viewMore,
                isLoading: tab?.hasImage && isLoading,
                isFlat: isFlat
            }, genKey(tabILink.href)),
            tabConfig?.carousel ? /*#__PURE__*/ _jsx(CarouselProduct, {
                props: {
                    searcher,
                    items: tab?.items,
                    link: tabILink,
                    config: carouselConfig,
                    isLoading,
                    defaultImage
                }
            }, genKey(`${JSON.stringify(tab)}TabCarouselProduct`)) : /*#__PURE__*/ _jsx(GridProduct, {
                props: {
                    searcher,
                    items: tab?.items,
                    link: tabILink,
                    config: carouselConfig,
                    isLoading
                }
            }, genKey(`${JSON.stringify(tab)}GridProduct`))
        ]
    }, genKey(`TabProduct${tab}`));
};
export default TabProduct;

//# sourceMappingURL=index.js.map